export default {
  ui: {
    fields: [
      'invoice.yearmonth',
      'invoice.no',
      'invoice.date',
      'invoice.amount.total',
      'invoice.amount.taxSales',
      'invoice.amount.tax',
      'invoice.canceledAt',
      'invoice.buyer.id',
      'invoice.carrier.id1',
      'src',
      'meta.note',

      // A row with no invoice shows blanks in every column above it, which is
      // how one that never issued became invisible on the page that lists them.
      // These two say which kind it is: a date still to come means something
      // will try again, and no date at all means it is waiting on a person.
      'nextAttemptAt',
      'deadlineAt',
    ],
  },
}
